import { Typography, Box } from "@mui/material";

const CurrencySelectionHeader = ({ title }: { title: string }) => {
    return (
        <Box style={{ position: "sticky", top: -12, backgroundColor: "white", zIndex: 1 }}>
            <Typography variant="h3" m={1}>
                {title}
            </Typography>
        </Box>
    );
};

export default CurrencySelectionHeader;
